import { render, staticRenderFns } from "./PasswordConfirmation.vue?vue&type=template&id=5a3c0f26&"
import script from "./PasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports